import './Style.scss';
import * as React from 'react';
import { useAppDispatch, useAppSelector } from 'index';
import { loadAdminData } from 'actions/adminBootstrapActions';
import { LoadingComponent } from 'views/components/LoadingComponent';
import AdminToolbar from '../AdminToolbar';
import AdminSidebar from '../AdminSidebar';
import HierarchyNav from '../HierarchyNav';
import AdminGrid from '../AdminGrid';
import DetailPane from './DetailPane';

/**
 *  The admin tool itself. Replaces the #mainContent markup of admin.tmpl.jsp
 *  and the bootstrap in WebContent/assets/admin/js/admin.js.
 */
export default function AdminApp() {
  const dispatch = useAppDispatch();
  const groupsLoaded = useAppSelector((state) => state.admin.groups.loaded);
  const { view, detail, path } = useAppSelector((state) => state.admin.ui);

  React.useEffect(() => {
    void dispatch(loadAdminData());
  }, []);

  /**
   *  A form for something reached through the navigation appears as the last
   *  column, beside its siblings. Reached from the toolbar instead — with
   *  nothing selected — it takes over the whole area, as #rowMode used to.
   */
  const inlineForm = view === 'detail' && detail && path.length > 0
    && (detail.kind === 'group' || detail.kind === 'user');

  const main = () => {
    if (!groupsLoaded) {
      return <LoadingComponent />;
    }
    if (inlineForm && detail) {
      const form = (
        <div className="admin-column admin-column-form">
          <DetailPane detail={detail} />
        </div>
      );
      return <HierarchyNav trailing={form} />;
    }
    if (view === 'detail' && detail) {
      return <DetailPane detail={detail} />;
    }
    if (view === 'grid') {
      return <AdminGrid />;
    }
    return <HierarchyNav />;
  };

  return (
    <div className="admin-app" id="mainContent">
      <AdminToolbar />
      <div className="row admin-content">
        <div className="col-2 admin-sidebar">
          <AdminSidebar />
        </div>
        <div className="col-10 nopadding admin-main">
          {main()}
        </div>
      </div>
    </div>
  );
}
